import React, { ChangeEvent, useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import ReactPixel from "react-facebook-pixel";
import TagManager from "react-gtm-module";
import { Modal, Button, Form } from "react-bootstrap";
import "./Processpayment-modern.css";
import { Copy, GeoAltFill } from "react-bootstrap-icons";
import { FieldValues, useForm } from "react-hook-form";
import CustomRadio from "../customRadio";
import CustomInput from "../CustomInput";
import rules from "../../rules";
import {
  address_delivery_icon,
  registered_contact_logo,
  vehicle_inspection_car,
} from "../../assets/images";
import { useMutation, useQuery } from "@tanstack/react-query";
import { trackEvent } from "../../services/events";
import {
  Country,
  CountryState,
  CreateCart,
  CustomerDetails,
  DeliveryAddress,
  UpdateCart,
  UpdateNonCart,
} from "../../types";
import axiosInstance from "../../services/axios.instance";
import { API_URL } from "../../services/apiConfig";
import RentalSummary from "../CustomerDashBoard/RentalSummary";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";
import ErrorModal from "../ErrorModal";
import RentalSummarySecondPage from "../CustomerDashBoard/RentalSummarySecondPage";
import { useDispatch, useSelector } from "react-redux";
import { clearBookingValues, setBookingValues } from "../../Redux/BookingData/bookingDataSlice";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import { Capacitor } from "@capacitor/core";
import { PaymentSheetEventsEnum, Stripe } from "@capacitor-community/stripe";
import TermsModal from "../CustomerDashBoard/TermsAndCondition";
import { toast } from "react-toastify";
import ContactAddressMapModal from "../CustomerDashBoard/ManageMyProfile/ContactAddressMapModal";

interface bookingData {
  product_id: string;
  base_product_id: string;
  product_name: string;
  product_description: string;
  merchant_id: string;
  quantity: number;
  item_id: string;
  promotion_id: string;
  price: number;
  price_per_month: number;
  price_per_week: number;
  toppings: any[];
  buy_more_pay_less: object;
  discount_event: object;
  variant: object;
  shop_id: string;
  product_details: string;
}

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_URL}`);

const ProcessPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = Capacitor.isNativePlatform();
  // const stripePromise = loadStripe(
  //   "pk_test_51QprViCfdTe3ZY4exp3xHGFoqkxmSp8f732CTDUZN5lUlTE7Dp0zI5grQCRRRSaiI8uY3YnVx1xdJvE0RGlpviMK00BP60h719"
  // );

  const { bookingValues } = useSelector((state: any) => state.bookingValues);
  console.log("booking values in payment", JSON.stringify(bookingValues));

  // console.log(optionalData,"testing")

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState<string>("");
  const [isSameAsContact, setIsSameAsContact] = useState(false);
  const [state1, setState1] = useState<string>("");
  const [deliveryCountry, setDeliveryCountry] = useState<string>("");
  const [deliveryState, setDeliveryState] = useState<string>("");
  const [selectedCountryId, setSelectedCountryId] = useState<string>("");
  const [registeredInfo, setRegisteredInfo] = useState<CustomerDetails | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [stateData, setStateData] = useState<CountryState[]>([]);
  const [orderNumber, setOrderNumber] = useState<string>("");
  const [elements, setElements] = useState<any>(null);
  const [paymentElement, setPaymentElement] = useState<any>(null);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [customerLatitude, setCustomerLatitude] = useState<string>("");
  const [customerLongitude, setCustomerLongitude] = useState<string>("");
  const [showLocationModal, setShowLocationModal] = useState(false);

  // --- Vehicle Inspection States ---
  const [returnOption, setReturnOption] = useState<string>(bookingValues?.returnOption || "collect");
  const [availableMerchants, setAvailableMerchants] = useState<any[]>([]);
  const [selectedMerchantId, setSelectedMerchantId] = useState<string>(bookingValues?.selectedMerchantId || "");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0, openUpward: false, triggerTop: 0 });
  const [merchantId1, setMerchantId1] = useState<string>("");
  const [isAirportPickup, setIsAirportPickup] = useState<boolean>(false);
  const [showAirportOptions, setShowAirportOptions] = useState<boolean>(false);
  const [isDriverPickupInAirport, setIsDriverPickupInAirport] = useState<boolean>(false);
  const [showAirportError, setShowAirportError] = useState<boolean>(false);
  const [deliveryOptionError, setDeliveryOptionError] = useState<string>("");
  const [nearestBranchError, setNearestBranchError] = useState<string>("");
  const [deliveryFee, setDeliveryFee] = useState<number>(0);
  const [bookingPayload, setBookingPayload] = useState<bookingData>({
    product_id: "",
    base_product_id: "",
    product_name: "",
    product_description: "",
    merchant_id: "",
    quantity: 1,
    item_id: "",
    promotion_id: "",
    price: 0,
    price_per_week: 0,
    price_per_month: 0,
    toppings: [],
    buy_more_pay_less: {},
    discount_event: {},
    variant: {},
    shop_id: "",
    product_details: "",
  });

  const {
    control,
    formState: { isValid },
    setValue,
    trigger,
    register,
    getValues,
  } = useForm({ mode: "onChange" });

  const handleLocationSelect = (selectedLocation: { name: string; latitude: number; longitude: number }) => {
    setCustomerLatitude(String(selectedLocation.latitude));
    setCustomerLongitude(String(selectedLocation.longitude));
    setValue("delivery_billingaddress", selectedLocation.name, { shouldValidate: true, shouldDirty: true });
    // Note: Do not overwrite the top-level contactAddress
  };

  const locationState = location.state || {};
  const {
    deliveryDetails,
    optionalData,
    deliveryData,
    selectedItem,
    merchantId,
    searchData,
    additionalDriverFee,
    babySeatAmount,
    cdw_Amount,
    scdw_Amount,
    pai_InsuranceAmount,
    campaignId,
  } = locationState;
  console.log("locationState", selectedItem);

  const isKirkosExecutive = bookingValues?.deliveryAmount === "Yes";
  const isDeliverToMe = bookingValues?.deliveryAmount === "No";

  const rentalTotalVat: number = selectedItem?.product_details_car?.totalVat ?? 0;
  const rentalTotalStripeFeeFinal: number = selectedItem?.product_details_car?.totalStripeFeeFinal ?? 0;

  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    }
    return null;
  };

  const decodedToken = decodeToken(accessToken);
  const customerId = decodedToken && decodedToken["customer-id"] ? decodedToken["customer-id"] : null;

  // --- Vehicle Inspection Mutations & Handlers ---
  const getNearestMerchant = useMutation({
    mutationFn: (data: { latitude: string; longitude: string }) =>
      axiosInstance.post(
        `${API_URL.GET_NEAREST_MERCHANT}?productId=${selectedItem?.product_id}&merchantId=${merchantId}`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        }
      ),
    onSuccess: (response) => {
      setAvailableMerchants(response.data.available_merchants || []);
    },
  });

  const handleClear = useMutation({
    mutationFn: () =>
      axiosInstance.get(`${API_URL.CLEAR_CART}/${customerId}/carts/${merchantId1 || merchantId}/clear`),
    onSuccess: () => {
      handleBooking.mutate(bookingPayload);
    },
    onError: (error) => {
      console.log("error", error);
    }
  });

  const handleBooking = useMutation({
    mutationFn: (userData: bookingData) =>
      axiosInstance.post(`${API_URL.BOOKING_NOW}/${customerId}/carts`, userData),
  });

  const getAdditionalOptions = useMutation({
    mutationFn: () =>
      axiosInstance.get(`${API_URL.ADDITIONAL_OPTIONS}/${merchantId}`, {
        headers: { "Content-Type": "application/json" },
      }),
    onSuccess: (response) => {
      if (response?.data?.isAirport) {
        setShowAirportOptions(true);
        setIsDriverPickupInAirport(response?.data?.isDriverPickupInAirport !== false);
      }
      if (response?.data?.isDriverPickupInAirport === false) {
        setShowAirportError(true);
      }
    },
    onError: (error) => {
      console.log("error", error);
    }
  });

  const deliveryFeeMutation = useMutation({
    mutationFn: () =>
      axiosInstance.get(`${API_URL.DELIVERY_FEE}/${merchantId}/${selectedItem?.product_id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          location: `0,0`,
        },
      }),
    onSuccess: (response) => {
      const charge = response?.data?.deliveryCharge || 0;
      if (returnOption === "collect") {
        setDeliveryFee(charge + charge);
      } else {
        setDeliveryFee(charge);
      }
    },
  });


  useEffect(() => {
    if (isDeliverToMe && (merchantId1 || merchantId) && accessToken) {
      deliveryFeeMutation.mutate();
    }
  }, [isDeliverToMe, merchantId, merchantId1, accessToken]);

  const handleMerchantSelection = (selectedId: string) => {
    setDeliveryFee(0);
    setSelectedMerchantId(selectedId);
    setNearestBranchError("");
    dispatch(
      setBookingValues({
        ...bookingValues,
        selectedMerchantId: selectedId,
      })
    );

    const selectedMerchant = availableMerchants.find((m) => m.merchant_id === selectedId);
    if (selectedMerchant) {
      const updatedPayload: bookingData = {
        product_id: selectedMerchant.product_id,
        base_product_id: selectedMerchant.product_id,
        product_name: selectedMerchant.product_name,
        product_description: selectedMerchant.product_details?.description || "",
        merchant_id: selectedMerchant.merchant_id,
        quantity: 1,
        item_id: "",
        promotion_id: "",
        price: selectedMerchant.inventories?.[Object.keys(selectedMerchant.inventories)[0]]?.price || 0,
        price_per_month: selectedItem?.product_details_car?.price_per_month,
        price_per_week: selectedItem?.product_details_car?.price_per_week,
        toppings: [],
        buy_more_pay_less: {},
        discount_event: {},
        variant: {},
        shop_id: selectedMerchant.vendor_IDs?.[0] || "",
        product_details: selectedMerchant.product_details?.description || "",
      };
      setBookingPayload(updatedPayload);
      if (merchantId1) {
        handleClear.mutate();
      }

    }
    setIsDropdownOpen(false);
  };

  const handleAirportPickupChange = (value: string) => {
    const isAirport = value === "Yes";
    setIsAirportPickup(isAirport);
    dispatch(
      setBookingValues({
        ...bookingValues,
        isAirport: isAirport,
        airportFee: isAirport && isDriverPickupInAirport ? 50 : 0,
      })
    );
  };

  const handleRadioChange = (value: string) => {
    setDeliveryOptionError("");
    if (value === "No") {
      setNearestBranchError("");
      setSelectedMerchantId("");
    }
    dispatch(
      setBookingValues({
        ...bookingValues,
        deliveryAmount: value,
        isAirport: false,
        airportFee: 0,
        ...(value === "No" ? { selectedMerchantId: "" } : {}),
      })
    );

    if (value === "No") {
      setReturnOption("collect");
      deliveryFeeMutation.mutate();
      const updatedPayload: bookingData = {
        product_id: selectedItem?.product_id,
        base_product_id: selectedItem?.product_id,
        product_name: selectedItem?.product_name,
        price_per_month: selectedItem?.product_details_car?.price_per_month,
        price_per_week: selectedItem?.product_details_car?.price_per_week,
        product_description: selectedItem?.product_details?.description || "",
        merchant_id: merchantId,
        quantity: 1,
        item_id: "",
        promotion_id: "",
        price: selectedItem?.vendor_product_inventories[0]?.price,
        toppings: [],
        buy_more_pay_less: {},
        discount_event: {},
        variant: {},
        shop_id: selectedItem?.vendor_product_inventories[0]?.vendor_id,
        product_details: selectedItem?.product_details?.description,
      };
      setBookingPayload(updatedPayload);
      handleClear.mutate();
    }
  };

  useEffect(() => {
    if (searchData?.pickupLocLatitude && searchData?.pickupLocLongitude) {
      getNearestMerchant.mutate({
        latitude: searchData.pickupLocLatitude,
        longitude: searchData.pickupLocLongitude,
      });
    }
    getAdditionalOptions.mutate();
  }, [searchData]);

  useEffect(() => {
    if (isDropdownOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const DROPDOWN_HEIGHT = 260; // estimated max dropdown height in px
      const spaceBelow = window.innerHeight - rect.bottom;
      const openUpward = spaceBelow < DROPDOWN_HEIGHT;
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        openUpward,
        triggerTop: rect.top + window.scrollY,
      });
    }
  }, [isDropdownOpen]);

  useEffect(() => {
    Stripe.initialize({
      publishableKey: `${process.env.REACT_APP_STRIPE_URL}`,
    });
  }, []);

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Confirm And Pay Screen",
        content_category: "RegisteredDetails",
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_RegisteredDetails_ConfirmAndPayScreen",
          app: "Kirkos_RegisteredDetails_ConfirmAndPayScreen_App",
        },
        event_category: "RegisteredDetails_Info",
        module: "RegisteredDetails",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
        const customerData: CustomerDetails = response.data;

        if (customerData) {
          const { customer_details } = customerData;
          const { firstName, lastName, phone_no, email, customer_address } = customer_details || {};

          // Populate form fields
          setValue("firstname", firstName || "");
          setValue("lastname", lastName || "");
          setValue("emailaddress", email || "");
          setValue("phonenumber", phone_no || "");

          // Extract address data from nested customer_address
          if (customer_address) {
            setValue("buildingFlatNumber", customer_address.address_1 || "");
            setValue("contactAddress", customer_address.location_info || "");
            setCountry(customer_address.country || "");
            setState1(customer_address.state || "");
            setValue("country", customer_address.country || "");
            setValue("state1", customer_address.state || "");
            setCustomerLatitude(customer_address.latitude || "");
            setCustomerLongitude(customer_address.longitude || "");
          }
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchCustomerDetails();
  }, [setValue]);

  const handleSubmit = async () => {
    if (!acceptedTerms) {
      toast.error("Please accept the Terms and Conditions to proceed.");
      return;
    }

    if (!deliveryDetails || !selectedItem || !merchantId || !searchData) {
      setErrorMessage("We're unable to proceed as some essential booking information is missing. Please refresh the page and try again, or contact support if the issue persists.");
      setShowErrorModal(true);
      return;
    }

    let {
      firstname: firstName,
      lastname: lastName,
      emailaddress: email,
      contactAddress: address,
      phonenumber: mobileNumber,
    }: FieldValues = getValues();

    const userData = {
      addressType: "",
      street: "",
      city: "",
      district: "",
      pinCode: "",
      mobileNumber,
      latitude: selectedItem?.merchant_latitude,
      longitude: selectedItem?.merchant_longitude,
      landMark: "",
      firstName,
      lastName,
      email,
      address: "",
      country,
      state: state1,
    };

    handleRegistration.mutate(userData);
    // dispatch(clearBookingValues());
  };

  const handleRegistration = useMutation({
    mutationFn: (userData: DeliveryAddress) =>
      axiosInstance.post(API_URL.DELIVERY_ADDRESS, userData),

    onSuccess: async (successResponse) => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("InitiateCheckout", {
        content_type: "payment_details",
        content_name: "Confirm And Pay Button",
        content_category: "RegisteredDetails",
        content_ids: [selectedItem?.product_id],
        content_name_product: selectedItem?.product_name,
      });
      TagManager.dataLayer({
        dataLayer: {
          event: "payment_initiated",
          page_type: "standard",
          page_path: window.location.pathname,
          page_url: window.location.href,
          product_id: selectedItem?.product_id,
          product_name: selectedItem?.product_name
        }
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_RegisteredDetails_ConfirmAndPayButtonSuccess",
          app: "Kirkos_RegisteredDetails_ConfirmAndPayButtonSuccess_App",
        },
        event_category: "RegisteredDetails_Info",
        module: "RegisteredDetails",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });
      console.log("successResponse", successResponse);
      handleUpdate.mutate(updateData);
    },
    onError: (error: any) => {
      setErrorMessage(error?.data?.message || "We encountered a technical issue while processing your registration. Our team has been notified. Please try again shortly.");
      setShowErrorModal(true);
    },
  });


  const [coordinates, setCoordinates] = useState<{
    latitude: string;
    longitude: string;
  }>({
    latitude: "",
    longitude: "",
  });
  const [shopInfo, setShopInfo] = useState<{
    shopName: string;
    shopId: string;
  }>({
    shopName: "",
    shopId: "",
  });
  const [productDetails, setProductDetails] = useState<any>(null);

  useEffect(() => {
    const getCartData = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_URL.GET_CART}/${customerId}/carts`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const merchantKey = Object.keys(response.data)[0];
        setMerchantId1(merchantKey);

        const merchantData = response.data[merchantKey];
        setCoordinates({
          latitude: merchantData.shop_information.shop_address.latitude,
          longitude: merchantData.shop_information.shop_address.longitude,
        });
        setShopInfo({
          shopName: merchantData.shop_information.shop_name,
          shopId: merchantData.shop_information.shop_id,
        });

        if (merchantData.products && merchantData.products.length > 0) {
          setProductDetails(merchantData.products[0]);
        }

        console.log("Cart data:", response.data);
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    if (customerId) {
      getCartData();
    }
  }, [customerId]);

  const handleUpdate = useMutation({
    mutationFn: (updateData: UpdateCart) =>
      axiosInstance.put(`${API_URL.UPDATE}/${customerId}/carts`, updateData),
    onSuccess: async (successResponse) => {
      console.log("successResponse", successResponse);
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("InitiateCheckout", {
        content_type: "Product",
        content_name: selectedItem?.product_name,
        content_category: "Checkout Page",
        content_ids: [selectedItem?.product_id],
        shop_name: shopInfo?.shopName || selectedItem?.shop_name,
      });

      await trackEvent({
        event_name: {
          web: "Kirkos_Checkout_Update_Cart",
          app: "Kirkos_Checkout_Update_Cart",
        },
        event_category: "Checkout_Process",
        module: "Checkout",
        payload: {
          updateData
        },
      });

      handleCreate.mutate(getCreateCartPayload());
    },
    onError: (error: any) => {
      console.log(error);
    },
  });

  const getCreateCartPayload = () => {
    const payload: any = {
      merchant_id: merchantId1 || merchantId,
      payment_method: "STRIPE",
    };

    // Only include promoCode if campaignId exists (from marketing landing page flow)
    if (campaignId) {
      payload.promoCode = campaignId;
    }

    return payload;
  };

  //-----------------------------------------

  const createPaymentIntent = async () => {
    // This should be a POST request to your backend to create a PaymentIntent
    const response = await axiosInstance.post(API_URL.PAY_MOBILE, {
      order_number: orderNumber,
    });
    return response.data.clientSecret;
  };

  const processStripePayment = async (orderNumber: string) => {
    // if (isMobile) {
    //   try {
    //     const clientSecret = await createPaymentIntent();

    //     await Stripe.createPaymentSheet({
    //       paymentIntentClientSecret: clientSecret,
    //       merchantDisplayName: orderNumber,
    //     });

    //     const { paymentResult } = await Stripe.presentPaymentSheet();

    //     if (paymentResult === PaymentSheetEventsEnum.Completed) {
    //       navigate(`/customer/paymentsuccess?order_number=${orderNumber}`);
    //       console.log("Payment successful");
    //       // Handle successful payment
    //     } else {
    //       console.log("Payment failed or cancelled");
    //     }
    //   } catch (error) {
    //     console.error("Payment error:", error);
    //   }
    // } else {
    try {
      const response = await axiosInstance.post(API_URL.PAY_MOBILE, {
        order_number: orderNumber,
      });

      const clientSecret = response.data.clientSecret;
      const finalAmount =
        bookingValues.totalRentalPrice + bookingValues.totalRentalPrice * 0.05;
      // Navigate to the payment page with necessary data
      navigate("/stripe-payment", {
        state: {
          ...location.state,
          orderNumber,
          amount: finalAmount.toFixed(2),
          clientSecret,
          customerId,
          merchantId: merchantId1 || merchantId,
        },
      });
    } catch (error) {
      console.error("Error processing order:", error);
    }
    // }
  };

  //----------------------------------------------

  const handleCreate = useMutation({
    mutationFn: (createData: CreateCart) =>
      axiosInstance.post(API_URL.CREATE_CART, createData, {
        headers: {
          location: "0,0",
          language: "english",
          // "unomi-session-id": "122333",
        },
      }),

    onSuccess: (successResponse) => {
      // console.log("successResponsecart", successResponse.data.order_number);
      // setOrderNumber(successResponse.data.order_number);
      // processStripePayment(successResponse.data.order_number);
      // dispatch(clearBookingValues());
      if (successResponse?.data?.order_number) {
        setOrderNumber(successResponse?.data?.order_number);
        processStripePayment(successResponse?.data?.order_number);
      }
      // handleClear.mutate();

      //setShowSuccessModal(true);
    },
    onError: (error: any) => {

      setErrorMessage(error?.data?.message || "We encountered a technical issue while processing your registration. Our team has been notified. Please try again shortly.");
      handleClear.mutate();
      dispatch(clearBookingValues());
      setShowErrorModal(true);

    },
  });

  const { data: countriesData } = useQuery<Country[], Error>({
    queryKey: ["countries"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.COUNTRY);
      return response.data;
    },
  });

  const handleCountryChange = async (e: any) => {
    const selectedCountryName = e.target.value;
    setCountry(selectedCountryName);

    const selectedCountry = countriesData?.find(
      (country) => country.countryName === selectedCountryName
    );

    if (selectedCountry) {
      setSelectedCountryId(selectedCountry.countryId.toString());

      const response = await axiosInstance.get(
        `${API_URL.STATE}${selectedCountry.countryId}`
      );
      setStateData(response.data);
    }
  };

  const handleDeliveryCountryChange = async (e: any) => {
    const selectedCountryName = e.target.value;
    setDeliveryCountry(selectedCountryName);

    const selectedCountry = countriesData?.find(
      (country) => country.countryName === selectedCountryName
    );

    if (selectedCountry) {
      setSelectedCountryId(selectedCountry.countryId.toString());

      const response = await axiosInstance.get(
        `${API_URL.STATE}${selectedCountry.countryId}`
      );
      setStateData(response.data);
    }
  };

  // const cdwDailyRate =
  //   selectedItem?.product_details_car?.collision_damage_waiver_model
  //     ?.daily_collision_damage_waiver;
  // const daysDifference = deliveryDetails?.daysDifference;

  // let cdwAmount = 0;
  // if (cdwDailyRate !== undefined && daysDifference !== undefined) {
  //   cdwAmount = cdwDailyRate * daysDifference;
  // }

  // const scdwDailyRate =
  //   selectedItem?.product_details_car?.super_collision_damage_waiver_model
  //     ?.daily_super_collision_damage_waiver;

  // let scdwAmount = 0;
  // if (scdwDailyRate !== undefined && daysDifference !== undefined) {
  //   scdwAmount = scdwDailyRate * daysDifference;
  // }
  const daysDifference = deliveryDetails?.daysDifference;

  const wtpDailyRate =
    selectedItem?.product_details_car?.wind_shield_protection;

  let wtpAmount = 0;
  if (wtpDailyRate !== undefined && daysDifference !== undefined) {
    wtpAmount = wtpDailyRate * daysDifference;
  }

  // const driverDailyRate = 35;

  // let additionalDriverAmount = 0;
  // if (driverDailyRate !== undefined && daysDifference !== undefined) {
  //   additionalDriverAmount = driverDailyRate * daysDifference;
  // }
  const {
    data: customerData,
    isLoading,
    isError,
    error,
  } = useQuery<CustomerDetails, Error>({
    queryKey: ["details"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
      // console.log(response, "response");
      return response.data;
    },
  });

  const CopyRegisteredInfo = async () => {
    const { customer_details } = customerData || {};
    const { firstName, lastName, phone_no, email, customer_address } =
      customer_details || {};

    // Copy basic fields
    setValue("first_Name", firstName);
    setValue("last_Name", lastName);
    setValue("email_address", email);
    setValue("phone_number", phone_no);

    // Copy address fields from nested customer_address
    if (customer_address) {
      setValue("delivery_buildingFlatNumber", customer_address.address_1 || "");
      setValue("delivery_billingaddress", customer_address.location_info || "");
      setDeliveryCountry(String(customer_address.country || ""));

      const selectedCountry = countriesData?.find(
        (item) => String(item.countryName) === String(customer_address.country)
      );

      if (selectedCountry) {
        setSelectedCountryId(selectedCountry.countryId.toString());

        const response = await axiosInstance.get(
          `${API_URL.STATE}${selectedCountry.countryId}`
        );
        setStateData(response.data);
      }
      setDeliveryState(String(customer_address.state || ""));
    }
  };

  useEffect(() => {
    if (!isLoading && customerData) {
      const { customer_details } = customerData || {};
      const { firstName, lastName, phone_no, email, address, state, country, customer_address } =
        customer_details || {};

      setValue("contactAddress", address);
      setValue("billingaddress", customer_address?.location_info);
      setValue("firstname", firstName);
      setValue("lastname", lastName);
      setValue("phonenumber", phone_no);
      setValue("emailaddress", email);
      setValue("country", country);
      setValue("state1", state);

      // If Kirkos Executive delivery or 'Deliver to me' is selected, populate address section
      if (deliveryData?.deliveredBy === "KIRKOS_EXECUTIVE" || isDeliverToMe) {
        setIsSameAsContact(true);
        CopyRegisteredInfo();
      }
    }
  }, [customerData, isLoading, deliveryData, isDeliverToMe, countriesData]);

  if (isLoading) return <div>Loading Customer Details...</div>;
  if (isError) return <div>Error Loading Details:{error.message}</div>;

  const handleSameAsContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsSameAsContact(checked);
    if (checked) {
      CopyRegisteredInfo();
    } else {
      // Optionally clear or leave as is
      setValue("first_Name", "");
      setValue("last_Name", "");
      setValue("email_address", "");
      setValue("phone_number", "");
      setValue("delivery_buildingFlatNumber", "");
      setValue("delivery_billingaddress", "");
      setDeliveryCountry("");
      setDeliveryState("");
    }
  };

  const handleConfirmAndPay = async () => {
    // 1. Validate Delivery Option Selection
    if (!bookingValues?.deliveryAmount) {
      setDeliveryOptionError("Please select how you would prefer to receive the car");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // 2. Validate Branch Selection (if Pickup)
    if (bookingValues?.deliveryAmount === "Yes" && !selectedMerchantId) {
      setNearestBranchError("Please select a branch for pickup");
      const errorSection = document.querySelector('.select-branch-section');
      errorSection?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // 3. Validate Delivery Address (if Kirkos Executive)
    if (bookingValues?.deliveryAmount === "No") {
      const firstName = getValues("first_Name");
      const lastName = getValues("last_Name");
      const emailAddress = getValues("email_address");
      const billingAddress = getValues("delivery_billingaddress");
      const buildingFlatNumber = getValues("delivery_buildingFlatNumber");
      const phoneNumber = getValues("phone_number");
      if (!firstName || !lastName || !emailAddress || !billingAddress || !buildingFlatNumber || !deliveryCountry || !deliveryState || !phoneNumber) {
        toast.error("Please fill in all required delivery address fields");
        return;
      }
    }

    // 4. Proceed to registration/checkout
    handleSubmit();
  };

  const formattedDate = moment(deliveryDetails?.pickupDateDiff).format(
    "YYYY-MM-DD"
  );
  const pickUpTimeFormat = deliveryDetails?.pickupTime;

  const formattedDropoffDate = moment(deliveryDetails?.dropDateDiff).format(
    "YYYY-MM-DD"
  );
  const dropOffTimeFormat = deliveryDetails?.dropOffTime;

  const updateData: UpdateNonCart = {
    [merchantId1 || merchantId]: {
      applied_discount_code: null,
      shop_information: {
        shop_address: {
          pinCode: "",
          businessName: "",
          address: "",
          landmark: "",
          city: " ",
          district: "",
          state: "",
          country: "",
          longitude: coordinates?.longitude || selectedItem?.merchant_longitude,
          latitude: coordinates?.latitude || selectedItem?.merchant_latitude,
          streetOrArea: "",
          ward: "",
          number_and_streetname: "",
          estimated_delivery_time: "",
          estimated_delivery_fee: "",
          shop_entity: "",
        },
        shop_name: shopInfo?.shopName || selectedItem?.shop_name,
        shop_id:
          shopInfo?.shopId ||
          selectedItem?.vendor_product_inventories[0]?.vendor_id,
        image: "",
      },
      delivery_charge: deliveryFee,
      delivery_location: {
        type: "delivery_location",
        address: deliveryDetails?.formData.pickUpLocation,
        street: "",
        city: " ",
        district: "",
        state: "",
        country: "",
        pinCode: "",
        latitude:
          searchData?.pickupLocLatitude || selectedItem?.merchant_latitude,
        longitude:
          searchData?.pickupLocLongitude || selectedItem?.merchant_longitude,
        landMark: "",
      },
      recollection_location: {
        type: "recollection_location",
        address: deliveryDetails?.formData.returnLocation,
        street: "",
        city: " ",
        district: "",
        state: "",
        country: "",
        pinCode: "",
        latitude: selectedItem?.merchant_latitude,
        longitude: selectedItem?.merchant_longitude,
        landMark: "",
      },
      note: "",
      matrix_user_id: "",
      delivery_date: deliveryDetails?.pickupDateTime,
      recollection_date: deliveryDetails?.dropDateTime,
      // recollection_date:
      //   moment(deliveryDetails?.dropDateDiff).format(
      //     "YYYY-MM-DDTkk:mm:ss.sss"
      //   ) + "Z",
      //recollection_date: deliveryDetails?.dropDateTime,
      order_total_amount: 0,
      delivered_by:
        bookingValues?.deliveryAmount === "Yes"
          ? "CUSTOMER"
          : bookingValues?.deliveryAmount === "No"
          ? "KIRKOS_EXECUTIVE"
          : deliveryData?.deliveredBy,
      rental_days: deliveryDetails?.daysDifference,
      products: [
        {
          price: selectedItem?.vendor_product_inventories[0]?.price,
          toppings: [],
          product_id: productDetails?.product_id || selectedItem?.product_id,
          base_product_id: productDetails?.product_id || selectedItem?.product_id,
          product_name: selectedItem?.product_name,
          product_description: selectedItem?.product_details?.description,
          gst: selectedItem?.gst,
          baby_seat: bookingValues.babySeatSelected || false,
          baby_seat_amount: optionalData?.baby_seat_amount || 0,
          price_per_day: selectedItem?.product_details_car?.price_per_day,
          price_per_month: selectedItem?.product_details_car?.price_per_month,
          price_per_week: selectedItem?.product_details_car?.price_per_week,
          pai_insurance_amount: optionalData?.pai_insurance_amount || 0,
          weekly_pai_insurance_amount:
            optionalData?.weekly_pai_insurance_amount || 0,
          monthly_pai_insurance_amount:
            optionalData?.monthly_pai_insurance_amount || 0,
          cdw_flag: optionalData?.cdw_flag || false,
          scdw_flag: optionalData?.scdw_flag || false,
          scdw_amount: optionalData?.scdw_amount || 0,
          weekly_scdw_amount: optionalData?.weekly_scdw_amount || 0,
          monthly_scdw_amount: optionalData?.monthly_scdw_amount || 0,
          cdw_amount: optionalData?.cdw_amount || 0,
          price_per_day_vat: selectedItem?.product_details_car?.price_per_day_vat,
          price_per_week_vat: selectedItem?.product_details_car?.price_per_week_vat,
          price_per_month_vat: selectedItem?.product_details_car?.price_per_month_vat,
          price_per_year_vat: selectedItem?.product_details_car?.price_per_year_vat,

          price_per_day_commission: selectedItem?.product_details_car?.price_per_day_commission,
          price_per_week_commission: selectedItem?.product_details_car?.price_per_week_commission,
          price_per_month_commission: selectedItem?.product_details_car?.price_per_month_commission,
          price_per_year_commission: selectedItem?.product_details_car?.price_per_year_commission,

          price_per_day_stripeFeeFinal: selectedItem?.product_details_car?.price_per_day_stripeFeeFinal,
          price_per_week_stripeFeeFinal: selectedItem?.product_details_car?.price_per_week_stripeFeeFinal,
          price_per_month_stripeFeeFinal: selectedItem?.product_details_car?.price_per_month_stripeFeeFinal,
          price_per_year_stripeFeeFinal: selectedItem?.product_details_car?.price_per_year_stripeFeeFinal,

          price_per_day_stripeTax: selectedItem?.product_details_car?.price_per_day_stripeTax,
          price_per_week_stripeTax: selectedItem?.product_details_car?.price_per_week_stripeTax,
          price_per_month_stripeTax: selectedItem?.product_details_car?.price_per_month_stripeTax,
          price_per_year_stripeTax: selectedItem?.product_details_car?.price_per_year_stripeTax,

          price_per_day_stripeFee: selectedItem?.product_details_car?.price_per_day_stripeFee,
          price_per_week_stripeFee: selectedItem?.product_details_car?.price_per_week_stripeFee,
          price_per_month_stripeFee: selectedItem?.product_details_car?.price_per_month_stripeFee,
          price_per_year_stripeFee: selectedItem?.product_details_car?.price_per_year_stripeFee,
          weekly_cdw_amount: optionalData?.weekly_cdw_amount,
          monthly_cdw_amount: optionalData?.monthly_cdw_amount,
          is_airport: bookingValues?.isAirport,
          airport_fee: bookingValues?.airportFee,
          wind_shield_protection: optionalData?.wind_shield_protection,
          additional_driver: optionalData?.additional_driver || false,
          additional_driver_amount: optionalData?.additional_driver ? (additionalDriverFee || 0) : 0,
          merchant_id: merchantId1 || merchantId,
          quantity: 1,
          item_id: productDetails?.product_id || selectedItem?.product_id,
          buy_more_pay_less: null,
          discount_event: null,
          variant: {},
          shop_id: shopInfo?.shopId,
        },
      ],
      delivery_address: {
        type: "DELIVERY_ADDRESS",
        addressType: "",
        firstName: isKirkosExecutive ? getValues("firstname") : getValues("first_Name"),
        lastName: isKirkosExecutive ? getValues("lastname") : getValues("last_Name"),
        address: "",
        street: "",
        city: " ",
        district: " ",
        state: state1,
        country: country,
        pinCode: "",
        mobileNumber: isKirkosExecutive ? getValues("phonenumber") : getValues("phone_number"),
        latitude: customerLatitude,
        longitude: customerLongitude,
        landMark: "",
        email: isKirkosExecutive ? getValues("emailaddress") : getValues("email_address"),
        customer_address: {
          address_1: getValues("delivery_buildingFlatNumber") || "",
          street: "",
          city: "",
          district: "",
          state: state1 || "",
          country: country || "",
          pin_code: "",
          latitude: customerLatitude || "",
          longitude: customerLongitude || "",
          location_info: getValues("billingaddress") || "",
          address_type: "DELIVERY"
        }
      },
    },
  };

  if (
    !location.state ||
    !deliveryDetails ||
    !selectedItem ||
    !merchantId ||
    !searchData
  ) {
    return null;
  }

  const handleBack = () => {
    navigate("/customer/unified-booking", {
      state: location.state
    });
  };

  return (
    <>
      <div className="process-payment-container">
        <div className="row g-4 mb-5 mb-md-0">
          {/* Left Column: Forms */}
          <div className="col-lg-8">
            <div className="card card-custom h-100">
              <div className="card-body">
                {/* Page Header */}
                <div className="d-flex align-items-center gap-3 mb-5">
                  <img src={vehicle_inspection_car} alt="" className="header-icon" />
                  <h1 className="page-head-add mb-0">Vehicle pickup and drop off preferences</h1>
                </div>

                {/* Vehicle Inspection Section */}
                <div className="mb-5 delivery-address-section-highlight">
                  <div className="d-flex align-items-center gap-2 mb-4">
                    <div className="section-header-bar"></div>
                    <h2 className="page-head-add fs-5 mb-0">How would you prefer to receive the car?</h2>
                  </div>

                  <div className="options-grid">
                    <div
                      className={`option-card ${bookingValues?.deliveryAmount === "Yes" ? 'selected' : ''}`}
                      onClick={() => handleRadioChange("Yes")}
                    >
                      <div style={{ pointerEvents: 'none' }}>
                        <CustomRadio
                          onChange={() => { }}
                          checked={bookingValues?.deliveryAmount === "Yes"}
                          label=""
                        />
                      </div>
                      <div className="option-content">
                        <div className="radio-label-noninsurence">Pickup by myself</div>
                      </div>
                    </div>

                    <div
                      className={`option-card ${bookingValues?.deliveryAmount === "No" ? 'selected' : ''}`}
                      onClick={() => handleRadioChange("No")}
                    >
                      <div style={{ pointerEvents: 'none' }}>
                        <CustomRadio
                          onChange={() => { }}
                          checked={bookingValues?.deliveryAmount === "No"}
                          label=""
                        />
                      </div>
                      <div className="option-content">
                        <div className="radio-label-noninsurence">Deliver to me</div>
                      </div>
                    </div>
                  </div>

                  {deliveryOptionError && (
                    <div className="text-danger mt-2 fw-bold">{deliveryOptionError}</div>
                  )}
                </div>

                {/* Conditional Content Based on Selection */}
                {bookingValues?.deliveryAmount && (
                  <>
                    {/* Nearest Branch Section (Pickup) */}
                    {bookingValues?.deliveryAmount === "Yes" && availableMerchants.length > 0 && (
                      <div className="mb-5 select-branch-section delivery-address-section-highlight">
                        <div className="d-flex align-items-center gap-2 mb-4">
                          <div className="section-header-bar"></div>
                          <h2 className="page-head-add fs-5 mb-0">Select Branch</h2>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="contactinfo_text_label">Nearest Branches <span className="text-danger">*</span></div>
                            <div className="custom-dropdown-wrapper" ref={dropdownRef}>
                              <div
                                className={`bagroundcolor ${isDropdownOpen ? 'active' : ''}`}
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                              >
                                {selectedMerchantId
                                  ? availableMerchants.find(m => m.merchant_id === selectedMerchantId)?.shop_name
                                  : "Select Merchant"
                                }
                              </div>

                              {isDropdownOpen && createPortal(
                                <div className="custom-dropdown-portal-container">
                                  <div className="dropdown-backdrop" onClick={() => setIsDropdownOpen(false)}></div>
                                  <div
                                    className="custom-dropdown-list"
                                    style={dropdownPos.openUpward ? {
                                      bottom: window.innerHeight - dropdownPos.triggerTop + 5,
                                      top: 'auto',
                                      left: dropdownPos.left,
                                      width: dropdownPos.width,
                                      position: 'fixed',
                                      maxHeight: '240px',
                                      overflowY: 'auto',
                                    } : {
                                      top: dropdownPos.top + 5,
                                      left: dropdownPos.left,
                                      width: dropdownPos.width,
                                      position: 'absolute',
                                      maxHeight: '240px',
                                      overflowY: 'auto',
                                    }}
                                  >
                                    <div
                                      className="dropdown-item merchant-name text-white"
                                      onClick={() => handleMerchantSelection("")}
                                    >
                                      Select Merchant
                                    </div>
                                    {availableMerchants.map((merchant) => (
                                      <div
                                        key={merchant.merchant_id}
                                        className={`dropdown-item ${selectedMerchantId === merchant.merchant_id ? 'selected' : ''}`}
                                        onClick={() => handleMerchantSelection(merchant.merchant_id)}
                                      >
                                        <div className="merchant-name">{merchant.shop_name}</div>
                                        <div className="merchant-address">
                                          {merchant.shop_address?.address}, {merchant.shop_address?.state}, {merchant.shop_address?.country}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>,
                                document.body
                              )}
                            </div>
                            {nearestBranchError && (
                              <div className="text-danger mt-2 fw-bold">{nearestBranchError}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Registered Contact Info Section (Show for both or based on choice) */}
                    {isKirkosExecutive && (
                      <div className="mb-5 delivery-address-section-highlight">
                        <div className="d-flex align-items-center gap-2 mb-4">
                          <div className="section-header-bar"></div>
                          <h2 className="page-head-add fs-5 mb-0">Registered Contact Info</h2>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              First Name
                            </div>
                            <CustomInput
                              inputName="firstname"
                              inputType="firstname"
                              editable={isKirkosExecutive}
                              showLock={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="Alex"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.username}
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              Last Name
                            </div>
                            <CustomInput
                              inputName="lastname"
                              inputType="lastname"
                              editable={isKirkosExecutive}
                              showLock={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="John"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.username}
                            />
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Email Address
                            </div>
                            <CustomInput
                              inputName="emailaddress"
                              inputType="emailaddress"
                              editable={isKirkosExecutive}
                              showLock={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="alexjohn2021@gmail.com"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.email}
                            />
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Phone Number
                            </div>
                            <div className={isMobile ? "phone-number-input-container-mobile" : "phone-number-input-container"}>
                              <span className={isMobile ? "payment_new_country_codestyle_mobile" : "payment_new_country_codestyle"}>+971</span>
                              <CustomInput
                                inputName="phonenumber"
                                inputType="phonenumber"
                                editable={isKirkosExecutive}
                                showLock={true}
                                showEditIcon={true}
                                control={control}
                                className={isMobile ? "contactinfo_text_input_style_mobile" : "contactinfo_text_input_style"}
                                placeholder=""
                                onInputChange={(value: string) => { }}
                                rules={rules.AuthRules.phone_number}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Delivery Address Section (Deliver) */}
                    {isDeliverToMe && (
                      <div className="mt-5 delivery-address-section-highlight">
                        {/* Return Option Sub-selection */}
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <div className="section-header-bar"></div>
                            <h3 className="page-head-add fs-6 mb-0">Return Option</h3>
                          </div>
                          <div className="options-grid">
                            <div
                              className={`option-card ${returnOption === "dropoff" ? 'selected' : ''}`}
                              onClick={() => {
                                setReturnOption("dropoff");
                                dispatch(setBookingValues({ ...bookingValues, returnOption: "dropoff" }));
                                deliveryFeeMutation.mutate();
                              }}
                            >
                              <div style={{ pointerEvents: 'none' }}>
                                <CustomRadio
                                  onChange={() => { }}
                                  checked={returnOption === "dropoff"}
                                  label=""
                                />
                              </div>
                              <div className="option-content">
                                <div className="radio-label-noninsurence">Drop off by myself</div>
                              </div>
                            </div>

                            <div
                              className={`option-card ${returnOption === "collect" ? 'selected' : ''}`}
                              onClick={() => {
                                setReturnOption("collect");
                                dispatch(setBookingValues({ ...bookingValues, returnOption: "collect" }));
                                deliveryFeeMutation.mutate();
                              }}
                            >
                              <div style={{ pointerEvents: 'none' }}>
                                <CustomRadio
                                  onChange={() => { }}
                                  checked={returnOption === "collect"}
                                  label=""
                                />
                              </div>
                              <div className="option-content">
                                <div className="radio-label-noninsurence">Collect from me</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Airport Options */}
                        {showAirportOptions && (
                          <div className="mb-5 pt-3 border-top border-theme-dark">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="section-header-bar"></div>
                              <h3 className="page-head-add fs-6 mb-0">Is the Pickup Location at the Airport?</h3>
                            </div>
                            <div className="options-grid">
                              {!showAirportError && (
                                <div
                                  className={`option-card ${bookingValues?.isAirport === true ? 'selected' : ''}`}
                                  onClick={() => handleAirportPickupChange("Yes")}
                                >
                                  <div style={{ pointerEvents: 'none' }}>
                                    <CustomRadio
                                      onChange={() => { }}
                                      checked={bookingValues?.isAirport === true}
                                      label=""
                                    />
                                  </div>
                                  <div className="option-content">
                                    <div className="radio-label-noninsurence">Yes</div>
                                  </div>
                                </div>
                              )}
                              <div
                                className={`option-card ${bookingValues?.isAirport === false ? 'selected' : ''}`}
                                onClick={() => handleAirportPickupChange("No")}
                              >
                                <div style={{ pointerEvents: 'none' }}>
                                  <CustomRadio
                                    onChange={() => { }}
                                    checked={bookingValues?.isAirport === false}
                                    label=""
                                  />
                                </div>
                                <div className="option-content">
                                  <div className="radio-label-noninsurence">No</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="d-flex align-items-center gap-2 mb-4">
                          <div className="section-header-bar"></div>
                          <h2 className="page-head-add fs-5 mb-0">Address for Delivery</h2>
                        </div>

                        {/* Delivery Address Form Fields */}
                        <div className="row g-3 form-row-gap">
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              First Name <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <CustomInput
                              inputName="first_Name"
                              inputType="first_Name"
                              editable={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="Alex"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.username}
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              Last Name <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <CustomInput
                              inputName="last_Name"
                              inputType="last_Name"
                              editable={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="John"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.username}
                            />
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Email Address <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <CustomInput
                              inputName="email_address"
                              inputType="email_address"
                              editable={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="alexjohn2021@gmail.com"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.email}
                            />
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Building / Flat / House Number <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <CustomInput
                              inputName="delivery_buildingFlatNumber"
                              inputType="delivery_buildingFlatNumber"
                              editable={true}
                              showEditIcon={true}
                              control={control}
                              className="contactinfo_text_input_style"
                              placeholder="21B flat"
                              onInputChange={(value: string) => { }}
                              rules={rules.AuthRules.address}
                            />
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Contact Address <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <div onClick={() => setShowLocationModal(true)} style={{ cursor: "pointer", position: "relative" }}>
                              <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 10 }} />
                              <CustomInput
                                inputName="delivery_billingaddress"
                                inputType="delivery_billingaddress"
                                editable={true}
                                control={control}
                                className="contactinfo_text_input_style pe-4"
                                placeholder="Select location from map"
                                onInputChange={(value: string) => { }}
                                rules={rules.AuthRules.address}
                              />
                              <div style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", color: "#f1c260", zIndex: 11, pointerEvents: "none" }}>
                                <GeoAltFill size={16} />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-12">
                            <div className="contactinfo_text_label">
                              Phone Number <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <div className={isMobile ? "phone-number-input-container-mobile" : "phone-number-input-container"}>
                              <span className={isMobile ? "payment_new_country_codestyle_mobile" : "payment_new_country_codestyle"}>+971</span>
                              <CustomInput
                                inputName="phone_number"
                                inputType="phone_number"
                                editable={true}
                                showEditIcon={true}
                                control={control}
                                maxLength={9}
                                className={isMobile ? "contactinfo_text_input_style_mobile" : "contactinfo_text_input_style"}
                                placeholder="554885599"
                                onInputChange={(value: string) => { }}
                                rules={rules.AuthRules.phone_number}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row g-3 form-row-gap">
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              Country <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <select
                              className="bagroundcolor"
                              onChange={handleDeliveryCountryChange}
                              value={deliveryCountry}
                            >
                              <option value="">Select Country</option>
                              {countriesData?.map((country) => (
                                <option key={country.countryId} value={country.countryName}>
                                  {country.countryName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <div className="contactinfo_text_label">
                              State <span className="contactinfo_text_labelstar">*</span>
                            </div>
                            <select
                              className="bagroundcolor"
                              value={deliveryState}
                              onChange={(e) => setDeliveryState(e.target.value)}
                            >
                              <option value="">Select State</option>
                              {stateData?.map((state) => (
                                <option key={state.id} value={state.state_name}>
                                  {state.state_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Terms and Conditions Checkbox — hidden on mobile (sticky footer has its own) */}
                <div className="terms-checkbox-container mt-4 mb-2 d-none d-md-flex">
                  <div className="d-flex align-items-center gap-2 custom-theme-checkbox">
                    <input
                      type="checkbox"
                      id="termsCheckbox"
                      className="form-check-input"
                      checked={acceptedTerms}
                      onChange={(e) => setAcceptedTerms(e.target.checked)}
                    />
                    <label htmlFor="termsCheckbox" className="mb-0 cursor-pointer opacity-75">
                      I have read and accepted the{" "}
                      <span
                        className="text-theme-gold text-decoration-underline"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowTermsModal(true);
                        }}
                      >
                        Terms and Conditions
                      </span>
                    </label>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="payment-actions">
                  <button
                    className="btn all_button_style order-back_button_outline"
                    type="button"
                    onClick={handleBack}
                    disabled={handleRegistration.isPending || handleUpdate.isPending || handleCreate.isPending}
                  >
                    BACK
                  </button>
                  <button
                    className="btn all_button_style confirm-btn"
                    type="button"
                    onClick={handleConfirmAndPay}
                    disabled={handleRegistration.isPending || handleUpdate.isPending || handleCreate.isPending}
                  >
                    CONFIRM
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Rental Summary */}
          <div className="col-lg-4">
            <div className="sticky-sidebar">
              <RentalSummarySecondPage
                daysDifference={deliveryDetails.daysDifference}
                totalAmount={deliveryDetails.totalAmount}
                childSeatAmount={babySeatAmount}
                onDataFromRentalSummary={(data: any) => {
                  console.log("Data from Rental Summary:", data);
                }}
                paiInsuranceAmount={pai_InsuranceAmount}
                cdwAmount={cdw_Amount}
                scdwAmount={scdw_Amount}
                deliveryFee={deliveryFee}
                additionalDriverFee={additionalDriverFee || 0}
                carImage={selectedItem?.product_details?.images?.[0]}
                carModel={selectedItem?.product_details_car?.car_model}
                seat={selectedItem?.product_details_car?.number_of_seats}
                fuelType={selectedItem?.product_details_car?.fuel_type}
                isLastPage={true}
                airportFee={bookingValues?.airportFee || 0}
                wtpAmount={wtpAmount}
                rentalTotalVat={rentalTotalVat}
                rentalTotalStripeFeeFinal={rentalTotalStripeFeeFinal}
                merchantId={merchantId1 || merchantId}
              />
            </div>
          </div>
        </div>
        <TermsModal
          show={showTermsModal}
          onHide={() => setShowTermsModal(false)}
        />

        <SuccessModal
          isOpen={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          onNav={() => {
            navigate("/customer/selectpayment");
          }}
          message={`Your Order Placed Successfully<br /><span style="font-size: 18px">${orderNumber}</span>`}
        />

        <ErrorModal
          isOpen={showErrorModal}
          onClose={() => {
            setShowErrorModal(false);
            navigate("/customer/myaccount");
          }}
          message={errorMessage || "We're currently experiencing a brief technical interruption. Our team is working to resolve this as quickly as possible to ensure a smooth experience for you. Please try again in a few moments. We appreciate your patience!"}
        />

        {/* Mobile Sticky Buttons */}
        <div className="payment-mobile-sticky-actions-container">
          <div className="terms-checkbox-container-mobile px-4 py-2 bg-theme-dark-80">
            <div className="d-flex align-items-center justify-content-center gap-2 custom-theme-checkbox">
              <input
                type="checkbox"
                id="termsCheckboxMobile"
                className="form-check-input"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              <label htmlFor="termsCheckboxMobile" className="mb-0 cursor-pointer small opacity-75">
                I have read and accepted the{" "}
                <span
                  className="text-theme-gold text-decoration-underline"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowTermsModal(true);
                  }}
                >
                  Terms & Conditions
                </span>
              </label>
            </div>
          </div>
          <div className="payment-mobile-sticky-actions">
            <button className="btn all_button_style order-back_button_outline" onClick={handleBack} disabled={handleRegistration.isPending || handleUpdate.isPending || handleCreate.isPending}>BACK</button>
            <button className="btn all_button_style confirm-btn" onClick={handleConfirmAndPay} disabled={handleRegistration.isPending || handleUpdate.isPending || handleCreate.isPending}>CONFIRM</button>
          </div>
        </div>

      </div>
      <ContactAddressMapModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onLocationSelect={handleLocationSelect}
        initialLocation={
          customerLatitude && customerLongitude
            ? {
              latitude: parseFloat(customerLatitude),
              longitude: parseFloat(customerLongitude),
            }
            : { latitude: 25.1972, longitude: 55.2744 }
        }
        initialAddress={getValues("delivery_billingaddress")}
        title="Select Contact Address"
      />
    </>
  );
};

export default ProcessPayment;
